export const CommunicationEvents = {
  ERROR: "ERROR",
  CHANGE_STATUS: "CHANGE_STATUS",

  // Chatroom Events
  JOIN_CHATROOM: 'JOIN_CHATROOM',
  USER_CHATROOMS: 'USER_CHATROOMS',
  JOIN_CHATROOM_RESPONSE: 'JOIN_CHATROOM_RESPONSE',

  DELETE_CHATROOM: 'DELETE_CHATROOM',
  DELETE_CHATROOM_RESPONSE: 'DELETE_CHATROOM_RESPONSE',


  CHANGE_CHATROOM_STATUS: 'CHANGE_CHATROOM_STATUS',
  CHANGE_CHATROOM_STATUS_RESPONSE: 'CHANGE_CHATROOM_STATUS_RESPONSE',

  CHANGE_CHATROOM_VISIBILITY: 'CHANGE_CHATROOM_VISIBILITY',
  CHANGE_CHATROOM_VISIBILITY_RESPONSE: 'CHANGE_CHATROOM_VISIBILITY_RESPONSE',

  CHANGE_CHATROOM_NOTIFICATIONS: 'CHANGE_CHATROOM_NOTIFICATIONS',
  CHANGE_CHATROOM_NOTIFICATIONS_RESPONSE: 'CHANGE_CHATROOM_NOTIFICATIONS_RESPONSE',

  // Message Events
  CHATROOM_MESSAGES: 'CHATROOM_MESSAGES',
  FETCH_CHATROOM_MESSAGES: 'FETCH_CHATROOM_MESSAGES',

  BROADCAST_MESSAGE: "BROADCAST_MESSAGE",

  SEND_MESSAGE: "SEND_MESSAGE",
  SEND_MESSAGE_RESPONSE: 'SEND_MESSAGE_RESPONSE',

  SEND_BULK_MESSAGE: 'SEND_BULK_MESSAGE',
  SEND_BULK_MESSAGE_RESPONSE: 'SEND_BULK_MESSAGE_RESPONSE',

  DELETE_MESSAGE: "DELETE_MESSAGE",
  BROADCAST_DELETE_MESSAGE: "BROADCAST_DELETE_MESSAGE",

  // Notification Chatroom Events
  TOAST_NOTIFICATION: 'TOAST_NOTIFICATION',
  JOIN_NOTIFICATION_CHATROOM: 'JOIN_NOTIFICATION_CHATROOM',
  JOIN_NOTIFICATION_CHATROOM_RESPONSE: 'JOIN_NOTIFICATION_CHATROOM_RESPONSE',

  // User Online/Offline Status
  STATUS_CHANGED: 'STATUS_CHANGED',
  STATUS_ONLINE_CHANGE: 'STATUS_ONLINE_CHANGE',
  STATUS_OFFLINE_CHANGE: 'STATUS_OFFLINE_CHANGE',

  // Payment Events
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED'
};

export const StreamingEvents = {
  ERROR: 'ERROR',

  // Channel Events
  JOIN_CHANNEL: 'JOIN_CHANNEL',
  LEAVE_CHANNEL: 'LEAVE_CHANNEL',
  UPDATE_CHANNEL: 'UPDATE_CHANNEL',
  SET_STREAMER_CHANNEL: 'SET_STREAMER_CHANNEL',
  SET_STREAMING_CHANNEL: 'SET_STREAMING_CHANNEL',

  INITIALIZE_STREAMER_CHANNEL: 'INITIALIZE_STREAMER_CHANNEL',
  INITIALIZE_STREAMER_CHANNEL_COMPLETED: 'INITIALIZE_STREAMER_CHANNEL_COMPLETED',
  INITIALIZE_CHANNEL: 'INITIALIZE_CHANNEL',

  START_STREAMING: 'START_STREAMING',
  START_STREAMING_RESPONSE: 'START_STREAMING_RESPONSE',

  STOP_STREAMING: 'STOP_STREAMING',
  STOP_STREAMING_RESPONSE: 'STOP_STREAMING_RESPONSE',

  FETCH_USER_LIVE_CHANNEL: 'FETCH_USER_LIVE_CHANNEL',
  FETCH_USER_LIVE_CHANNEL_RESPONSE: 'FETCH_USER_LIVE_CHANNEL_RESPONSE',

  SEND_STREAMING_DATA: 'START_SEND_STREAMING_DATA',

  STREAMING_CHANNEL_MESSAGES: 'STREAMING_CHANNEL_MESSAGES',
  FETCH_STREAMING_CHANNEL_MESSAGES: 'FETCH_STREAMING_CHANNEL_MESSAGES',
  BROADCAST_STREAMING_CHANNEL_MESSAGE: 'BROADCAST_STREAMING_CHANNEL_MESSAGE',
  SEND_STREAMING_CHANNEL_TEXT_MESSAGE: 'SEND_STREAMING_CHANNEL_TEXT_MESSAGE',

  // Streaming Tip Events
  STREAMING_TIP_SENT_NOTIFICATION: 'STREAMING_TIP_SENT_NOTIFICATION',
  STREAMING_TIP_BROADCAST_TIP_RECEIVED: 'STREAMING_TIP_BROADCAST_TIP_RECEIVED'
};

export const Face2FaceEvents = {
  ERROR: 'ERROR',
  CALL_USER:"CALL_USER",
  UPDATE_CALL_REQUEST:"UPDATE_CALL_REQUEST",
  INITIALIZE_SESSION: 'INITIALIZE_SESSION',
  INITIALIZE_SESSION_RESPONSE:'INITIALIZE_SESSION_RESPONSE',
  INITIALIZE_SESSION_RECEIVED_BY_PERFORMER: 'INITIALIZE_SESSION_RECEIVED_BY_PERFORMER',
  CALL_DECLINE_BY_PERFORMER:'CALL_DECLINE_BY_PERFORMER',
  CALL_DECLINE_BY_PERFORMER_RESPONSE:'CALL_DECLINE_BY_PERFORMER_RESPONSE',
  CALL_DECLINE_BY_PERFORMER_RESPONSE_FOR_USER:'CALL_DECLINE_BY_PERFORMER_RESPONSE_FOR_USER',
  SEND_VEDIO_STREAM_TO_USER: 'SEND_VEDIO_STREAM_TO_USER',
  SEND_USER_VEDIO_STREAM_TO_PERFORMER: 'SEND_USER_VEDIO_STREAM_TO_PERFORMER',
  CALL_END_BY_PERFORMER: 'CALL_END_BY_PERFORMER',
  UPDATE_REMANING_TIME_AFTER_5_SEC: 'UPDATE_REMANING_TIME_AFTER_5_SEC',
  CALL_DISCONNECTED_TIME_UP:'CALL_DISCONNECTED_TIME_UP',
  CALL_EXTEND_REQUEST_BY_USER:'CALL_EXTEND_REQUEST_BY_USER',
  CALL_EXTEND_REQUEST_DICLINE_BY_PERFORMER:'CALL_EXTEND_REQUEST_DICLINE_BY_PERFORMER',
  CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER:'CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER',
  CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER_RESPONSE_TO_USER:'CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER_RESPONSE_TO_USER',
  CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER_RESPONSE_TO_PERFOMER:'CALL_EXTEND_REQUEST_ACCEPT_BY_PERFORMER_RESPONSE_TO_PERFOMER',
  UNACCEPTED_CALL_CUTBY_USER:'UNACCEPTED_CALL_CUTBY_USER',
  UNACCEPTED_CALL_CUTBY_USER_FOR_USER:'UNACCEPTED_CALL_CUTBY_USER_FOR_USER',
  UNACCEPTED_CALL_CUTBY_USER_FOR_PERFORMER:'UNACCEPTED_CALL_CUTBY_USER_FOR_PERFORMER',
  CALL_REQUEST_TIMED_OUT: 'CALL_REQUEST_TIMED_OUT',
  CALL_REQUEST_TIMED_OUT_TO_USER: 'CALL_REQUEST_TIMED_OUT_TO_USER',
  CALL_REQUEST_TIMED_OUT_TO_PERFORMER: 'CALL_REQUEST_TIMED_OUT_TO_PERFORMER',
  ACCEPTED_CALL_END_BY_USER:'ACCEPTED_CALL_END_BY_USER',
  ACCEPTED_CALL_END_BY_USER_RESPONSE_FOR_PERFORMER:'ACCEPTED_CALL_END_BY_USER_RESPONSE_FOR_PERFORMER',
  CALL_IS_ENDING_ACKNOWLEDGMENT: 'CALL_IS_ENDING_ACKNOWLEDGMENT',
  CALL_IS_ENDING_ACKNOWLEDGMENT_RECEIVED: 'CALL_IS_ENDING_ACKNOWLEDGMENT_RECEIVED',
  CLOSE_FACE2FACE_CALL: 'CLOSE_FACE2FACE_CALL',
  LOG_FACE_2_FACE_ERROR:'LOG_FACE_2_FACE_ERROR',
  UPDATE_SETTING_IN_SESSION:'UPDATE_SETTING_IN_SESSION',
  SESSION_RECONNECT_CALL_FORM_USER_SIDE:'SESSION_RECONNECT_CALL_FORM_USER_SIDE',
  SESSION_RECONNECT_CALL_FORM_USER_SIDE_RESPONSE_TO_USER:'SESSION_RECONNECT_CALL_FORM_USER_SIDE_RESPONSE_TO_USER',
  SESSION_RECONNECT_CALL_FORM_USER_SIDE_RESPONSE_TO_PERFORMER:'SESSION_RECONNECT_CALL_FORM_USER_SIDE_RESPONSE_TO_PERFORMER',
  LEAVE_CALL_DUE_TO_CALL_DISCONNECTED_AND_TRING_TO_RECONNECT:'LEAVE_CALL_DUE_TO_CALL_DISCONNECTED_AND_TRING_TO_RECONNECT',
  STAY_ON_CALL_WHILE_CALL_TRING_TO_RECONNECT:'STAY_ON_CALL_WHILE_CALL_TRING_TO_RECONNECT',
  FACE2FACE_CALL_DISCONNECT_COUNTDOWN_POPUP_SHOWN:'FACE2FACE_CALL_DISCONNECT_COUNTDOWN_POPUP_SHOWN',
  CAMERA_PERMISSION_ERROR_IN_RECEIVER_SIDE:'CAMERA_PERMISSION_ERROR_IN_RECEIVER_SIDE',
  CAMERA_PERMISSION_ERROR_IN_CALLER_SIDE:'CAMERA_PERMISSION_ERROR_IN_CALLER_SIDE',
  CAMERA_PERMISSION_ERROR_IN_CALLER_SIDE_RESPONSE_TO_RECEIVER:'CAMERA_PERMISSION_ERROR_IN_CALLER_SIDE_RESPONSE_TO_RECEIVER',
  SEND_MESSAGE_TO_USER_BY_PERFORMER:'SEND_MESSAGE_TO_USER_BY_PERFORMER',
  SEND_MESSAGE_TO_USER_BY_PERFORMER_SEND_RESPONSE_TO_USER:'SEND_MESSAGE_TO_USER_BY_PERFORMER_SEND_RESPONSE_TO_USER',
  SET_USER_CALL_SCREEN_STATUS: 'SET_USER_CALL_SCREEN_STATUS',
  SET_PERFORMER_CALL_SCREEN_STATUS: 'SET_PERFORMER_CALL_SCREEN_STATUS',
  USER_CONNECTING_SCREEN_STATUS_SEND_BY_PERFORMER: 'USER_CONNECTING_SCREEN_STATUS_SEND_BY_PERFORMER',
  USER_MEDIA_PERMISSION_STATUS_SEND_TO_PERFORMER: 'USER_MEDIA_PERMISSION_STATUS_SEND_TO_PERFORMER',
  DISCONNECT_CALL_FROM_USER_SIDE_WHEN_PERFORMER_INACTIVE: 'DISCONNECT_CALL_FROM_USER_SIDE_WHEN_PERFORMER_INACTIVE',
  DISCONNECT_CALL_FROM_PERFORMER_SIDE_WHEN_USER_INACTIVE: 'DISCONNECT_CALL_FROM_PERFORMER_SIDE_WHEN_USER_INACTIVE',
  FACE2FACE_CALL_STATS: 'FACE2FACE_CALL_STATS',
  START_USER_TIMER: 'START_USER_TIMER',
  SEND_F2F_TIP_NOTIFICATION_TO_PERRFORMER: 'SEND_F2F_TIP_NOTIFICATION_TO_PERRFORMER',
   // rejoin notification to user from performer
  SEND_REJOIN_NOTIFICATION_TO_USER_FROM_PERFORMER: 'SEND_REJOIN_NOTIFICATION_TO_USER_FROM_PERFORMER',
  SEND_REJOIN_NOTIFICATION_RESPONSE_TO_PERFORMER_FROM_USER: 'SEND_REJOIN_NOTIFICATION_RESPONSE_TO_PERFORMER_FROM_USER',
   // check performer is on call or not
  CHECK_PERFORMER_ACTIVE_ON_CALL_STATUS: 'CHECK_PERFORMER_ACTIVE_ON_CALL_STATUS',
 
   // rejoin notification to performer from user
  SEND_REJOIN_NOTIFICATOIN_TO_PERFORMER_FROM_USER: 'SEND_REJOIN_NOTIFICATOIN_TO_PERFORMER_FROM_USER',
  SEND_REJOIN_NOTIFICATOIN_RESPONSE_TO_USER_FROM_PERFORMER: 'SEND_REJOIN_NOTIFICATOIN_RESPONSE_TO_USER_FROM_PERFORMER',
  SEND_REPORT_AND_END_CALL_BY_USER: 'SEND_REPORT_AND_END_CALL_BY_USER'
}


